<template>
  <div class="response">
    <div style="       overflow: auto; width: 200px;    padding: 0px 10px; text-align: left;padding-right:10px;  border-right: 1px solid #f2f2f2;  height: calc(100vh - 96px);">
      <responseRight @modelFun="modelFun"></responseRight>
 
    </div>
    <codeRight :str="str" style="flex:1"></codeRight>
    <!-- <div style="width:450px">
     
        </div> -->
  </div>
</template>
<script>
import responseRight from "./responseRight.vue";
import codeRight from "./codeRight.vue";

export default {
  name: "Home",
  components: {
    responseRight,
    codeRight
  },
  data() {
    return {
      str:''
    }
  },
  methods:{
    modelFun(val){
      console.log('111111111111111111111111111',val)
      this.str= val;
   
    }
  }
};
</script>
<style scoped>
.response {
  width: 100%;
  height: 100%;
  display: flex;
  /* padding-left: 188px; */
  height: calc(100vh - 95px);
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  overflow: auto;

  /* position: relative; */
}
.response::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Opera */
}
</style>